import { Component, output, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone:false,
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./color-picker.component.scss']
})
export class ColorPickerComponent {
  readonly onColorChange = output<string|undefined>();

  public selectedColor?:string;

  public onChange() {
    this.onColorChange.emit(this.selectedColor);
  }

}
